import * as React from 'react'
// import {useAuth0} from '@auth0/auth0-react'
import {client} from './api-client'

function useAuthClient() {
  //   const {getAccessTokenSilently} = useAuth0()

  return React.useCallback(
    async (endpoint, config) => {
      //   const token = await getAccessTokenSilently()
      //   console.log('getToken', {token})
      return client(endpoint, {
        ...config,
        token:
          'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InJNQVhxLUM2ek1KVnFTMVFaRXpBNCJ9.eyJ1c2VyX3JvbGVzIjpbIkFkbWluIl0sIm5ldHdvcmtfaWQiOiJBbWl0LlJhbWFzaGFua2FyU2luZ2hAdGhyeXYuY29tIiwiZW1haWwiOiJBbWl0LlJhbWFzaGFua2FyU2luZ2hAdGhyeXYuY29tIiwiZmlyc3RuYW1lIjoiQW1pdCIsImxhc3RuYW1lIjoiUmFtYXNoYW5rYXIgU2luZ2giLCJpc3MiOiJodHRwczovL29vZS1kZXYudXMuYXV0aDAuY29tLyIsInN1YiI6Im9pZGN8T2t0YS1PT0VEZXZ8MDB1MW14bXJ2bGRXdjJhaGkwaDgiLCJhdWQiOlsiaHR0cHM6Ly9vb2UudGhyeXYuY29tLyIsImh0dHBzOi8vb29lLWRldi51cy5hdXRoMC5jb20vdXNlcmluZm8iXSwiaWF0IjoxNzQxMDkzMjA0LCJleHAiOjE3NDExNzk2MDQsInNjb3BlIjoib3BlbmlkIHByb2ZpbGUgZW1haWwiLCJhenAiOiJsWVZ2WVVFakpuSmF4dnlSek9aTFZBcXBjUUZOalNwRyJ9.jOesN3tnprvocp8U2achIDkibAS6HJyRzXRaqAx5GPDVfLJBNKn3ZPSnvKWKRLmDG7V3fmH2Zg7_wpl54cCabPDe0hvwtlAG8lcbRqkULAC9oK6jnO5mlTHFRWdGu1eZAiNxZ4QSyrdt0_wwhxL6XqdjwrS3N6eftf2jxBskv-5G1jbxv6hgqzetuW-RzgQp5Yn3vVrXXy8QWjnYhMT_z2bp13PAbEyTqardkjiVXqXMN8dV5rVNqj9QDukT7um8ZR-85oiUvMHFJExM_MnYvEV5hXQgGdWxOLQIgnK5-sogDSA0K1_MnYrrytAvmKrdmrz-dzSG93RZ9KoYVyA6Ow',
      })
    },
    // getAccessTokenSilently won't never change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )
}

export {useAuthClient}
